// // src/layouts/Carousel_slider/Carousel_slider.jsx

// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Navigation } from 'swiper/modules';
// import './swiper.css';
// import './swiper-bundle.css'; // Updated import for Swiper styles

// const CarouselSlider = () => {

//   const slides = [
//     {
//       title: "Ayushman Bharat Digital Mission (ABDM) with Modules M1, M2, and M3",
//       subtitle: "The Ayushman Bharat Digital Mission aims to create a comprehensive digital health ecosystem in India. The integration of various modules enhances the delivery of healthcare services, improving accessibility, interoperability, and patient management.",
//       imgSrc: "assets/images/Carousole/Abha.png",
//       link: "https://abdm.gov.in/",
//       buttonText: "Learn More",
//       imgStyle: { width: '490px', height: '401px', objectFit: 'cover' } // Individual style
//     },
//     {
//       title: "ITSC Technologies Pvt. Ltd",
//       subtitle: "With 25 years in healthcare Technology, ITSC Technology Pvt. Ltd. is a trusted provider of HMIS solutions, combining advanced software, robust hardware, and dedicated support. Our motto, ‘Your Trust, Our Commitment,’ reflects our focus on reliable, innovative solutions that empower healthcare providers to deliver exceptional patient care.",
//       imgSrc: "assets/images/Carousole/logo25.png",
//       link: "https://www.itscglobal.com/",
//       buttonText: "Visit ITSC"
//     },
//     {
//       title: "HMIS (e-Sehat)",
//       subtitle: "e-Sehat HMIS (Health Management Information System) is a comprehensive digital solution aimed at improving healthcare delivery. It facilitates efficient data collection, management, and reporting, enabling healthcare providers to enhance patient care, streamline operations, and make informed decisions based on real-time information.",
//       imgSrc: "assets/images/Carousole/HMIS.png"
//     },
//     {
//       title: "Material management",
//       subtitle: "Material management involves the systematic planning and control of materials and supplies within an organization. It includes procurement, inventory management, storage, and distribution, ensuring efficient resource utilization, cost reduction, and streamlined operations to support timely delivery and enhance overall productivity.",
//       imgSrc: "assets/images/Carousole/MaterialManagment.png"
//     },
//     {
//       title: "Medical Record Department (MRD)",
//       subtitle: "The Medical Record Department (MRD) is responsible for managing patient health records in healthcare facilities. This department ensures accurate documentation, storage, and retrieval of medical records, maintaining confidentiality and compliance with regulations. It plays a crucial role in patient care, billing, and quality assurance, facilitating communication among healthcare providers.",
//       imgSrc: "assets/images/Carousole/RegistrationID.png"
//     },
//     {
//       title: "LIS (Laboratory Information System) and RIS (Radiology Information System)",
//       subtitle: (
//         <>
//           LIS: A system for managing laboratory data, including test orders, results, and workflow, enhancing accuracy and communication in healthcare.<br />
//           <br />
//           RIS: A system for managing radiology information, handling scheduling, imaging orders, and reporting, streamlining processes and improving patient care.
//         </>
//       ),
//       imgSrc: "assets/images/Carousole/medicalID.png"
//     },
//     {
//       title: "Reporting and Analytics in Healthcare",
//       subtitle: "Reporting and analytics in healthcare involve analyzing clinical data to identify trends, improve patient outcomes, and optimize operational efficiency, enabling informed decision-making and enhancing overall quality of care.",
//       imgSrc: "assets/images/Carousole/phr.png",
//       link: "#pricing04-o",
//       buttonText: "More Modules"
//     }
//   ];

//   return (
//     <>
//       <div className="container">
//         <div className="row">
//           <div className="col-12">
//             <Swiper
//               spaceBetween={50}
//               slidesPerView={1}
//               pagination={{ clickable: true }}
//               navigation={{
//                 nextEl: '.swiper-button-next ',
//                 prevEl: '.swiper-button-prev',
//               }}
//               modules={[Autoplay, Navigation]}
//               autoplay={{ delay: 3000, disableOnInteraction: false }}
//               effect="slide"
//               speed={500}
//               loop={true}
//             >
//               {slides.map((slide, Carousel_slider) => (
//                 <SwiperSlide key={Carousel_slider}>
//                   <div className="d-flex flex-column flex-md-row p-3">

//                     <div className="col-12 col-md-6" style={{ textAlign: "left", marginTop: "10%", padding: "20px", position: "relative" }}>

//                       <div
//                         style={{
//                           display: "inline-flex",
//                           borderRadius: "50px",
//                           overflow: "hidden",
//                           boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
//                           // fontWeight: "bold",
//                           fontSize: "18px",
//                           color: "#fff",
//                           width: "200px",
//                           height: "50px",
//                         }}
//                       >
//                         {/* Left Half */}
//                         <div
//                           style={{
//                             backgroundColor: "#007ab3",
//                             flex: 1,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           e-Sehat
//                         </div>

//                         {/* Right Half */}
//                         <div
//                           style={{
//                             backgroundColor: "#00aaff",
//                             flex: 1,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                           }}
//                         >
//                           ITSC HMIS
//                         </div>
//                       </div>


//                       <h2 className="text-gradient h1-large">{slide.title}</h2>
//                       <span className="subtitle p-large">{slide.subtitle}</span>
//                       {slide.link && (
//                         <div>
//                           <a className="btn btn-primary" style={{ padding: '0.25rem 2rem' }} href={slide.link}>
//                             {slide.buttonText || "Read More"} {/* Use custom button text or default to "Read More" */}
//                           </a>
//                         </div>
//                       )}
//                     </div>

//                     <div className="col-12 col-md-6" style={{ textAlign: "center", padding: "20px" }}>
//                       <img
//                         src={slide.imgSrc}
//                         alt={slide.title}
//                         title={slide.title}
//                         style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover' }}
//                         className="img-fluid carousel-image" // Added carousel-image class
//                       />
//                     </div>

//                   </div>
//                 </SwiperSlide>
//               ))}
//               <div className="swiper-button-next"></div>
//               <div className="swiper-button-prev"></div>
//             </Swiper>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default CarouselSlider;



import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Carousel_slider = () => {
  const slides = [
    {
      title: "Ayushman Bharat Digital Mission (ABDM) with Modules M1, M2, and M3",
      subtitle: "The Ayushman Bharat Digital Mission aims to create a comprehensive digital health ecosystem in India. The integration of various modules enhances the delivery of healthcare services, improving accessibility, interoperability, and patient management.",
      imgSrc: "assets/images/Carousole/Abha.png",
      link: "https://abdm.gov.in/",
      buttonText: "Learn More"
    },
    {
      title: "ITSC Technologies Pvt. Ltd",
      subtitle: "With 25 years in healthcare Technology, ITSC Technology Pvt. Ltd. is a trusted provider of HMIS solutions, combining advanced software, robust hardware, and dedicated support. Our motto, 'Your Trust, Our Commitment,' reflects our focus on reliable, innovative solutions that empower healthcare providers to deliver exceptional patient care.",
      imgSrc: "assets/images/Carousole/logo25.png",
      link: "https://www.itscglobal.com/",
      buttonText: "Visit ITSC"
    },
    {
      title: "HMIS (e-Sehat)",
      subtitle: "e-Sehat HMIS (Health Management Information System) is a comprehensive digital solution aimed at improving healthcare delivery. It facilitates efficient data collection, management, and reporting, enabling healthcare providers to enhance patient care, streamline operations, and make informed decisions based on real-time information.",
      imgSrc: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&h=600&fit=crop"
    },
    {
      title: "Material management",
      subtitle: "Material management involves the systematic planning and control of materials and supplies within an organization. It includes procurement, inventory management, storage, and distribution, ensuring efficient resource utilization, cost reduction, and streamlined operations to support timely delivery and enhance overall productivity.",
      imgSrc: "assets/images/Carousole/mm.png"
    },
    {
      title: "Medical Record Department (MRD)",
      subtitle: "The Medical Record Department (MRD) is responsible for managing patient health records in healthcare facilities. This department ensures accurate documentation, storage, and retrieval of medical records, maintaining confidentiality and compliance with regulations. It plays a crucial role in patient care, billing, and quality assurance, facilitating communication among healthcare providers.",
      imgSrc: "assets/images/Carousole/mrd.png"
    },
    {
      title: "LIS (Laboratory Information System) and RIS (Radiology Information System)",
      subtitle: "LIS: A system for managing laboratory data, including test orders, results, and workflow, enhancing accuracy and communication in healthcare. RIS: A system for managing radiology information, handling scheduling, imaging orders, and reporting, streamlining processes and improving patient care.",
      imgSrc: "https://images.unsplash.com/photo-1581595220975-119360b1c63f?w=800&h=600&fit=crop"
    },
    {
      title: "Reporting and Analytics in Healthcare",
      subtitle: "Reporting and analytics in healthcare involve analyzing clinical data to identify trends, improve patient outcomes, and optimize operational efficiency, enabling informed decision-making and enhancing overall quality of care.",
      imgSrc: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
      link: "#pricing04-o",
      buttonText: "More Modules"
    }
  ];

  return (
    <>
      <style>{`
        .carousel-container {
          min-height: 100vh;
             padding: 2rem 1rem;
        }

        .carousel-wrapper {
          max-width: 1200px;
          margin: 0 auto;
        }

        .slide-content {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          padding: 1.5rem;
        }

        @media (min-width: 768px) {
          .slide-content {
            flex-direction: row;
            align-items: center;
            padding: 2.5rem;
          }
        }

        .text-section {
          flex: 1;
          text-align: left;
          padding: 1rem;
        }

        .brand-badge {
          display: inline-flex;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 20px;
          padding: 0.25rem 0.75rem;
          margin-bottom: 1.5rem;
          font-size: 0.75rem;
          font-weight: 600;
          color: white;
          gap: 0.5rem;
        }

        .slide-title {
          font-size: 1.5rem;
          font-weight: 700;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 1rem;
          line-height: 1.3;
        }

        @media (min-width: 768px) {
          .slide-title {
            font-size: 2rem;
          }
        }

        @media (min-width: 1024px) {
          .slide-title {
            font-size: 2.5rem;
          }
        }

        .slide-subtitle {
          font-size: 0.875rem;
          line-height: 1.6;
          color: #4a5568;
          margin-bottom: 1.5rem;
        }

        @media (min-width: 768px) {
          .slide-subtitle {
            font-size: 0.9375rem;
          }
        }

        .slide-button {
          display: inline-block;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 0.625rem 2rem;
          border-radius: 0.5rem;
          text-decoration: none;
          font-size: 0.875rem;
          font-weight: 600;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .slide-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
        }

        .image-section {
          flex: 1;
          text-align: center;
          padding: 1rem;
        }

        .carousel-image {
          max-width: 100%;
          height: auto;
          border-radius: 1rem;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        }

        .swiper {
          background: white;
          border-radius: 1.5rem;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
          overflow: hidden;
        }

        .swiper-button-next,
        .swiper-button-prev {
          color: #667eea;
          background: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .swiper-button-next:after,
        .swiper-button-prev:after {
          font-size: 1.25rem;
          font-weight: 700;
        }

        @media (max-width: 768px) {
          .swiper-button-next,
          .swiper-button-prev {
            display: none;
          }
        }

        .swiper-pagination-bullet {
          background: #667eea;
          opacity: 0.5;
          width: 10px;
          height: 10px;
        }

        .swiper-pagination-bullet-active {
          opacity: 1;
          background: #667eea;
        }
      `}</style>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <Swiper
            spaceBetween={30}
            slidesPerView={1}
            pagination={{ 
              clickable: true,
              dynamicBullets: true
            }}
            navigation={true}
            modules={[Autoplay, Navigation, Pagination]}
            autoplay={{ delay: 9000, disableOnInteraction: false }}
            speed={500}
            loop={true}
          >
            {slides.map((slide, Carousel_slider) => (
              <SwiperSlide key={Carousel_slider}>
                <div className="slide-content">
                  <div className="text-section">
                    <div className="brand-badge">
                      <span>e-Sehat</span>
                      <span>ITSC HMIS</span>
                    </div>
                    <h2 className="slide-title">{slide.title}</h2>
                    <p className="slide-subtitle">{slide.subtitle}</p>
                    {slide.link && (
                      <a className="slide-button" href={slide.link}>
                        {slide.buttonText || "Read More"}
                      </a>
                    )}
                  </div>
                  <div className="image-section">
                    <img
                      src={slide.imgSrc}
                      alt={slide.title}
                      className="carousel-image"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default Carousel_slider;
